export const toggleOfferTableComparisonPopup = () => {
	const offerTables = $(".offer-table, .offer-table__extra-content");

	if (offerTables) {
		offerTables.each(function () {
			const that = $(this);
			const comparisonPopupContainer = that.find(".offer-comparison");
			const comparisonPopupButton = comparisonPopupContainer.find(".offer-comparison__link");
			const comparisonPopupExitButton = comparisonPopupContainer.find(".comparison-table-header-bar__button");
			const comparisonPopup = comparisonPopupContainer.find(".offer-comparison__pop-up");

			comparisonPopupButton.off().click(function () {
				bodyScrollLock.disableBodyScroll(comparisonPopup);
				comparisonPopup.addClass("show-pop-up");
				setTimeout(function timeoutFunction() {
					comparisonPopup.focus();
				}, 100);
				console.log("document.activeElement", document.activeElement);
				console.log("comparisonPopup", comparisonPopup);
				return false;
			});

			comparisonPopupExitButton.click(function () {
				bodyScrollLock.enableBodyScroll(comparisonPopup);
				comparisonPopup.removeClass("show-pop-up");
				comparisonPopupButton.focus();
				return false;
			});
		})
	}
}
